











































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { State } from 'vuex-class'

import { Location } from 'vue-router'

import { ActionButton, DropDownButton } from '@/models'

import MobileAppBar from './MobileAppBar.vue'
import MobileNavigationBar from './MobileNavigationBar.vue'
import { isFood } from '@/utils'

@Component({
  components: {
    MobileAppBar,
    MobileNavigationBar
  }
})
export default class MobileLayout extends Vue {
  @Prop({ type: Boolean, default: false })
  readonly backButton!: boolean

  @Prop({ type: String })
  readonly backButtonIcon?: string

  @Prop({ type: Array })
  readonly buttons?: (ActionButton | DropDownButton)[]

  @Prop({ type: Boolean, default: false })
  readonly hasFab!: boolean

  @Prop({ type: Boolean, default: false })
  readonly isFullScreen!: boolean

  @Prop({ type: Boolean, default: true })
  readonly showFooter!: boolean

  @Prop({ type: Boolean, default: true })
  readonly showShadow!: boolean

  @Prop({ type: String })
  readonly title?: string | null

  footerButtons: { icon: string; text: string; route: Location }[] = [
    {
      icon: isFood() ? 'room_services' : 'shopping_basket',
      route: { name: 'Orders' },
      text: 'Pedidos'
    },
    {
      icon: 'attach_money',
      route: { name: 'Invoices' },
      text: isFood() ? 'Comandas' : 'Compras'
    },
    {
      icon: isFood() ? 'fastfood' : 'list_alt',
      route: { name: 'ItemGroups' },
      text: isFood() ? 'Cardápio' : 'Catálogo'
    },
    {
      icon: 'more_horiz',
      route: { name: 'More' },
      text: 'Mais'
    }
  ]

  @State
  readonly modalCount!: number

  @State
  readonly showNewVersionNotification!: boolean

  @Watch('hasFab')
  onHasFabChange () {
    Vue.nextTick(this.fixNotificationPosition)
  }

  @Watch('modalCount')
  onModalCountChange () {
    Vue.nextTick(this.fixNotificationPosition)
  }

  @Watch('showFooter')
  onShowFooterChange () {
    Vue.nextTick(this.fixNotificationPosition)
  }

  created () {
    Vue.nextTick(this.fixNotificationPosition)
  }

  beforeDestroy () {
    const bodyClasses = document.getElementsByTagName('body')[0].classList

    bodyClasses.remove('has-modal', 'mobile-footer', 'bottom-fab')
  }

  fixNotificationPosition () {
    const bodyClasses = document.getElementsByTagName('body')[0].classList

    if (this.modalCount > 0) {
      bodyClasses.add('has-modal')
    } else {
      bodyClasses.remove('has-modal')
    }

    if (this.showFooter) {
      bodyClasses.add('mobile-footer')
    } else {
      bodyClasses.remove('mobile-footer')
    }

    if (this.hasFab) {
      bodyClasses.add('bottom-fab')
    } else {
      bodyClasses.remove('bottom-fab')
    }
  }

  checkOverlaySlot () {
    return this.$slots.overlay !== undefined
  }
}
